var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Twitter",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Twitter",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.574 3.091c-.581-.664-1.356-1.088-2.301-1.091-1.455-.005-1.994.53-2.546 1.083-.852.948-.847 2.078-.628 2.962-2.875-.093-5.414-1.516-7.041-3.692A5.363 5.363 0 00.786 4.03a5.284 5.284 0 003.202 4.875c-1.012 0-2.442-.291-3.26-.767.174 1.875 1.88 3.452 3.55 4.1A8.659 8.659 0 010 13.373 9.079 9.079 0 005.19 15c5.08 0 9.197-4.172 9.208-9.323C15.356 5.084 16 3.806 16 3.806s-.742.368-1.697.579c.816-.483 1.333-2.024 1.333-2.024s-.978.583-1.93.894a4.101 4.101 0 00-.132-.164z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgTwitterIcon;